export const ONE_MANY_SORRY_TEXTS = {
  title: 'Спасибо за интерес!',
  subtitle: 'Мы сообщим, когда занятия будут доступны.\nДеньги остались на вашей карте.',
  subtitleMobile:
    'Мы сообщим, когда занятия\nбудут доступны. Деньги\nостались на вашей карте.',
  button: 'На главную',
};

export const ONE_MANY_SORRY_TEXTS_MAIN = {
  free: {
    firstText: 'Спасибо за интерес к бесплатному эфиру!',
    secondText: 'Скоро свяжемся с вами по email и запишем на занятие!',
  },
  sub: {
    firstText: 'Спасибо за интерес к новому формату!',
    secondText: 'Мы сообщим, когда занятия будут доступны.',
  },
};
